import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getRequest = createAsyncThunk('/party/getRequest',
    async ({ tag }) => {
        try {
            const myurl = `${V_URL}/user/get-request`;
            const bodyFormData = new URLSearchParams();
            bodyFormData.append('tag', tag);
            bodyFormData.append('project', localStorage.getItem('U_PROJECT_ID'))
            const response = await axios({
                method: 'post',
                url: myurl,
                data: bodyFormData,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });
            const data = response.data;
            // console.log(data, "getRequest response");
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            
            toast.error(error.response.data.message);
            return error;
        }
    })

const getRequestSlice = createSlice({
    name: "getRequest",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getRequest.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getRequest.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getRequest.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getRequestSlice.reducer;